const SectionLabel = ({ children }) => (
  <p className="text-[11px] font-medium text-brand tracking-[0.08em] uppercase mb-2">
    {children}
  </p>
);

export default SectionLabel;
